import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import {db} from "@src/services/db";
import "@src/services/echo";

type SessionHasNewMessageEventPayload = {
    id: number;
};

export const HasNewMessageSetSessionEvent = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();

    const companyId = Number((auth.user as any)?.company_id ?? 0);
    if (!companyId) return;

    // @ts-ignore
    window.websockets
        .private(`company.${companyId}`)
        .listen(".MarkAsSeenSessionEvent ", async (event: SessionHasNewMessageEventPayload) => {
            try {

                if (!event?.id) return;

                const id = Number(event.id);

                //update no IndexedDB
                await db.sessions.update(id, {
                    has_new_messages: false,
                    updated_at: Date.now(),
                } as any);

                // se estiver aberta, atualiza também
                if (Number((sessionStore.selectedSession as any)?.id) === id) {
                    (sessionStore.selectedSession as any).has_new_messages = false;
                }
            } catch (e) {
                console.error("❌ erro no listener HasNewMessageSet", e);
            }
        });
};